import * as mutationTypes from "../mutationTypes";
import { UserInfoDto } from '@/zh-website/src/model';
import { ICT_USER_INFO } from '@/zh-website/src/model/data';

export interface State {
  userInfo: UserInfoDto|null
}

const initState: State = {
  userInfo: null
};
const mutations = {
  [mutationTypes.SET_USER_INFO](state: State, userInfo: UserInfoDto) {
    window.localStorage.setItem(ICT_USER_INFO, JSON.stringify(userInfo))
    state.userInfo = userInfo;
  }
};

const getters = {
  userInfo: (state: State): UserInfoDto|null => state.userInfo,
};

export default {
  state: initState,
  mutations,
  getters,
}
